import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home.vue'),
    meta: { keys: "/",title:"首页" }
  },
  {
    path: '/abouts',
    name: '关于我们',
    component: () => import('@/views/abouts/abouts.vue'),
    meta: { keys: "abouts",title:"关于我们" },
		children: [{
				path: 'companyProfile',
				name: '公司简介',
				component: () => import('@/views/abouts/companyProfile.vue'),
				meta: { keys: "abouts",title:"关于我们" }
			},{
				path: 'developmentHistory',
				name: '发展历程',
				component: () => import('@/views/abouts/developmentHistory.vue'),
				meta: { keys: "abouts",title:"关于我们" }
			},{
				path: 'corporateCulture',
				name: '企业文化',
				component: () => import('@/views/abouts/corporateCulture.vue'),
				meta: { keys: "abouts",title:"关于我们" }
			},{
				path: 'honor',
				name: '荣誉资质',
				component: () => import('@/views/abouts/honor.vue'),
				meta: { keys: "abouts",title:"关于我们" }
			},
    ]
  },
  {
    path: '/services',
    name: '服务领域',
    component: () => import('@/views/services.vue'),
    meta: { keys: "services",title:"服务领域" }
  },
  {
    path: '/projecse',
    name: '项目展示',
    component: () => import('@/views/projecse/projecse.vue'),
    meta: { keys: "projecse",title:"项目展示" }
  },
  {
    path: '/projectDetails',
    name: '项目展示详情',
    component: () => import('@/views/projecse/projectDetails.vue'),
    meta: { keys: "projecse",title:"项目展示",hidens:true }
  },
  {
    path: '/news',
    name: '新闻中心',
    component: () => import('@/views/news/news.vue'),
    meta: { keys: "news",title:"新闻中心" }
  },
  {
    path: '/newsDetailse',
    name: '新闻中心详情',
    component: () => import('@/views/news/newsDetailse.vue'),
    meta: { keys: "news",title:"新闻中心",hidens:true }
  },
  {
    path: '/contens',
    name: '加入我们',
    component: () => import('@/views/contens/contens.vue'),
    meta: { keys: "contens",title:"加入我们" },
		children: [{
				path: 'talents',
				name: '联系我们',
				component: () => import('@/views/contens/talents.vue'),
				meta: { keys: "contens",title:"加入我们" }
			},{
				path: 'franchise',
				name: '企业加盟',
				component: () => import('@/views/contens/franchise.vue'),
				meta: { keys: "contens",title:"加入我们" }
			}
    ]
  },
  {
    path: '/searchs',
    name: '搜索',
    component: () => import('@/views/searchs.vue'),
    meta: { keys: "searchs",title:"搜索",hidens:true  }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
